import React, { useEffect, useState } from 'react';
import CodeEditor from '../../../../../components/material-ui/code_editor/CodeEditor';
import { Stack } from '@mui/material';
import CasinoBtnSave from '../../../../../components/casino/CasinoBtnSave';
import useNumberParams from '../../../../../hooks/useNumberParams';
import { API_CASINO } from '../../../../../api/casino';
import useToast from '../../../../../hooks/useToast';
import TabsLanguage from '../../../../../components/widgets/TabsLanguage';
import CusInput from '../../../../../components/material-ui/CusInput';
import useBootstrapSize from '../../../../../hooks/useBootstrapSize';
import CusLink from '../../../../../components/material-ui/CusLink';

export default function InsertHeadContent({ casino }) {
  const { successToast } = useToast();
  const { isMobile } = useBootstrapSize();

  const casinoId = useNumberParams('casinoId');
  const [currenLang, setCurrenLang] = useState();
  const [infoByLang, setInfoByLang] = useState({});

  useEffect(() => {
    API_CASINO.headData
      .get({ casinoId })
      .then((e) => {
        const data = e.data.data;
        setInfoByLang(data);
      })
      .catch(console.error);
  }, [casinoId]);

  const onCasinoClick = () => {
    API_CASINO.headData
      .set({ casinoId, data: infoByLang })
      .then(() => {
        successToast('Information updated successfully');
      })
      .catch(console.error);

    console.log('insertText', infoByLang);
  };

  const onDefaultClick = () => {
    const casinoName = casino.casinoName;
    const domain = casino.domain;

    let description =
      currenLang == 'ru'
        ? `${casinoName} — онлайн-казино c быстрыми выплатами и бонусами. Играй в слоты, рулетку и live-игры. Регистрируйся и получай бонус на первый депозит!`
        : `${casinoName} is an online casino with fast payouts and bonuses. Play slots, roulette, and live games. Register and get a first deposit bonus!`;

    const htmlHead = `<meta name="description" content="${description}">
<meta name="robots" content="index, follow">
<link rel="canonical" href="${domain}">

<meta property="og:title" content="${casinoName}" />
<meta property="og:type" content="website" />
<meta property="og:image" content="https://${domain}" />
<meta property="og:url" content="${domain}" />
<meta property="og:description" content="${casinoName}" />`;

    setInfoByLang((prev) => {
      const prevInfo = JSON.parse(JSON.stringify(prev));
      prevInfo[currenLang] = {
        title: casinoName,
        htmlHead: htmlHead
      };
      return prevInfo;
    });
  };

  return (
    <Stack gap={2}>
      <TabsLanguage lang={currenLang} setLang={setCurrenLang} />
      <Stack alignItems={'end'}>
        <CusLink linkComponent="button" text="Fill by default" onClick={onDefaultClick} />
      </Stack>
      <Stack gap={1}>
        <CusInput
          isRow={!isMobile}
          key={'insertHtml_title_' + currenLang}
          label={'Text for block <Title>'}
          value={infoByLang[currenLang]?.title}
          onChange={(e) => {
            const value = e.target.value;
            setInfoByLang((prev) => {
              const prevInfo = JSON.parse(JSON.stringify(prev));
              if (!prevInfo[currenLang]) prevInfo[currenLang] = {};
              prevInfo[currenLang].title = value;
              return prevInfo;
            });
          }}
        />
        <CodeEditor
          key={'insertHtml_data_' + currenLang}
          label={'Inserting HTML code between the <head></head> tags'}
          text={infoByLang[currenLang]?.htmlHead}
          setText={(val) =>
            setInfoByLang((prev) => {
              const prevInfo = JSON.parse(JSON.stringify(prev));
              if (!prevInfo[currenLang]) prevInfo[currenLang] = {};
              prevInfo[currenLang].htmlHead = val;
              return prevInfo;
            })
          }
          isOpenFind={false}
          mode="html"
          height={'calc(100svh - 450px)'}
        />
      </Stack>
      <CasinoBtnSave onClick={onCasinoClick} />
    </Stack>
  );
}
